import SecuredRoute from './SecuredRoute';

export default SecuredRoute;
